import moment from "moment";
import "moment/locale/es";
export class ValidateDateLocation {
    constructor() {
        this.validateDateGreaterThanToday = (date, days) => {
            if (date === null) {
                return moment().add(days, "days").format("YYYY-MM-DD");
            }
            const today = moment();
            const selectedDate = moment(date);
            if (selectedDate.isBefore(today) || selectedDate.isSame(today, "day")) {
                return moment().add(days, "days").format("YYYY-MM-DD");
            }
            return date;
        };
    }
}
